<template>
	<router-link  :to="{ name: apiPath, params: { poolId: id } }">
		<div class="pool-list-item">
			<div class="pool-list-item__content">
				<div class="pool-list-item__left">
					<p class="pool-list-item__name text-color--light-grey font-size--medium">{{ name }}</p>
					<p class="pool-list-item__sport text-color--light-grey-2">{{ sport }}</p>
				</div>
				<div class="pool-list-item__right">
					<i class="material-icons">keyboard_arrow_right</i>
				</div>
			</div>
			<div class="pool-list-item__manage-btn" v-if="userIsManager == true" >
				<router-link :to="{ name: 'manage-'.concat(apiPath), params: { poolId: id } }" class="btn--outlined btn-outlined--secondary text-color--secondary">
					Manage Pool
				</router-link>
			</div>
			
		</div>
	</router-link>
</template>

<script>
	export default {
		props: {
			id: Number,
			name: String,
			sport: String,
			userIsManager: Boolean,
			apiPath: String
		}
	}
</script>